import React, { useState, useEffect } from "react";
import Header from "./Header.js";
import Loader from "./Loader.js";
import GreyArrow from "../assets/greyLeftAr.png";
import { FaPen, FaTrash } from "react-icons/fa";
import delicon from "../assets/delete.svg";
import update from "../assets/editBlack.svg";
import { useNavigate } from "react-router-dom";
import "./Css/Viewtestimonial.css";
import FilterIcon from "../assets/filterIcon.png";
import Search from "../assets/search.png";
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import { Modal } from "react-bootstrap";
import { FaTimes, FaExclamationCircle } from "react-icons/fa";
import {
  options_search,
  GuestManagementPageText,
} from "./../CommonJquery/WebsiteText";
import {
  APL_LINK,
  server_post_data,
  delete_website_master_data,
  get_all_carmodel,
} from "../ServiceConnection/serviceconnection.js";
import {
  mondayDayYearFormat,
  handleError,
  computeTodayDate,
  handleIaphabetnumberChange,
  handleAphabetsChange,
  handleEmailChange,
  handleNumbersChange,
  computeplussevendays,
  goBack,
} from "../CommonJquery/CommonJquery.js";
import { Button } from "@mui/material";
import { ArrowLeft } from "lucide-react";

function CarModelView() {
  const navigate = useNavigate();
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [testimonials, setshowtestimonial] = useState([]);
  const [testimonialsImage, setshowtestimonialImage] = useState("");
  const [searchfilter, setSearchFilter] = useState("");
  const [startDate, setStartDate] = useState(computeplussevendays());
  const [endDate, setEndDate] = useState(computeTodayDate());
  const [selectedValue, setSelectedValue] = useState("Name");
  const [filteredData, setfilteredData] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [showDltModal, setshowDltModal] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Get paginated data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData
    ? filteredData.slice(indexOfFirstItem, indexOfLastItem)
    : [];
  const totalPages = filteredData
    ? Math.ceil(filteredData.length / itemsPerPage)
    : 0;

  // Handler for page changes
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Render pagination buttons
  const renderPaginationButtons = () => {
    const buttons = [];

    // Previous button
    buttons.push(
      <li className="cust_hist_page_item" key="prev">
        <button
          className="cust_hist_page_link cust_hist_page_prev"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <span className="sr-only">Previous</span>
          <svg
            className="cust_hist_page_icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </li>
    );

    // Page buttons
    // Show max 5 page buttons with current page in the middle when possible
    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, startPage + 4);

    // Adjust startPage if endPage is at maximum
    if (endPage === totalPages) {
      startPage = Math.max(1, endPage - 4);
    }

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <li className="cust_hist_page_item" key={i}>
          <button
            className={`cust_hist_page_link ${
              currentPage === i ? "cust_hist_page_active" : ""
            }`}
            onClick={() => handlePageChange(i)}
          >
            {i}
          </button>
        </li>
      );
    }

    // Next button
    buttons.push(
      <li className="cust_hist_page_item" key="next">
        <button
          className="cust_hist_page_link cust_hist_page_next"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages || totalPages === 0}
        >
          <span className="sr-only">Next</span>
          <svg
            className="cust_hist_page_icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </li>
    );

    return buttons;
  };

  const search_data = () => {
    const flag = "2";
    const call_id = "0";
    master_data_get(startDate, endDate, flag, call_id);
  };

  useEffect(() => {
    const flag = "1";
    let call_id = "0";
    master_data_get("", "", flag, call_id);
  }, []);
  const handleSelect = (event) => {
    setSelectedValue(event.target.value);
  };
  const master_data_get = async (startDate, endDate, flag, call_id) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("flag", flag);
    fd.append("start_date", startDate);
    fd.append("end_date", endDate);
    fd.append("call_id", call_id);
    fd.append("search_option", selectedValue);
    fd.append("search_data", document.getElementById("search_data").value);
    await server_post_data(get_all_carmodel, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          
          setshowtestimonial(Response.data.message.data);
          setfilteredData(Response.data.message.data);
          setshowtestimonialImage(Response.data.message.image_link);
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        // handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  const handleSearch = (event) => {
    const searchValue = event.target.value;
    setSearchFilter(searchValue);

    const filteredDatashow = testimonials.filter((row) => {
      return Object.values(row).some((value) => {
        if (value !== null && value !== undefined) {
          return (
            typeof value === "string"
              ? value.toLowerCase()
              : value.toString().toLowerCase()
          ).includes(searchValue.toLowerCase());
        }
        return false;
      });
    });

    setfilteredData(filteredDatashow);
  };

  const handleDelete = async (primaryId) => {
    let fd_from = new FormData();
    fd_from.append("id_for_delete", primaryId);
    fd_from.append("flag_for", 6);
    fd_from.append("for_status_final", "d");
    await server_post_data(delete_website_master_data, fd_from)
      .then((Response) => {
        setshowLoaderAdmin(false);
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          master_data_get("", "", 1, 0);
        }
      })
      .catch((error) => {
        console.log(error);
        setshowLoaderAdmin(false);
      });
  };

  const handleEdit = (index) => {
    navigate(`/Edit_carmodel/${index}`);
  };

  const handleNavigate = () => {
    navigate("/Add_Car_Type");
  };
  const handleDltCloseModal = () => {
    setshowDltModal(false);
  };
  const handleShowDltModl = (primaryId) => {
    setSelectedId(primaryId);
    setshowDltModal(true);
  };

  const handleDeleteYes = () => {
    if (selectedId) {
      handleDelete(selectedId);
    }
    setshowDltModal(false);
  };

  const exportToCSV = (csvData, fileName, fileExtension) => {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  return (
    <div className="dashboard">
      {showLoaderAdmin && <Loader />}
      <Header />
      <div className="container-lg"></div>
      <div className="dashboard_container">
        <div className="page_content">
          <div className="page_content_container">
            <div className="pageCntn_head">
              <div className="pageNameDiv">
                <div className="d-flex gap-2 align-items-center">
                  <p className="breadcrumb-item">View Car Type</p>
                  <img
                    src={GreyArrow}
                    alt="Rapid Car Leasing"
                    style={{ height: "14px" }}
                  />
                </div>
              </div>
              <div className={` alignCol bottomAlgin col-xl-3 mb-0`}>
                <div className="pageActionBtns">
                  <button
                    className="CSVBTN"
                    style={{ height: "38px" }}
                    // onClick={() =>
                    //   exportToCSV(ReservationDataList, "download_excel", ".xlsx")
                    // }
                  >
                    Download Excel
                  </button>
                </div>
              </div>
              <Button
                onClick={goBack}
                startIcon={
                  <ArrowLeft size={17} style={{ marginBottom: "2px" }} />
                }
                className="Back_bttn_page"
              >
                Back
              </Button>
            </div>

            <div className="page_body">
              <div className="viewStaff">
                <div className="viewStaff_head">
                  <div className="row m-0">
                    <div className="addTestno d-flex justify-content-end gap-2">
                      <button type="button" onClick={handleNavigate}>
                        Add Car Type
                      </button>
                      <div style={{ opacity: "0", pointerEvents: "none" }}>
                        <div className="inputDiv2 d-none">
                          <img src={Search} alt="Rapid Car Leasing" />
                          <input
                            type="text"
                            id="search_data"
                            onInput={(e) => {
                              if (selectedValue === options_search[0].value) {
                                handleAphabetsChange(e);
                              } else if (
                                selectedValue === options_search[1].value
                              ) {
                                handleEmailChange(e);
                              } else if (
                                selectedValue === options_search[2].value
                              ) {
                                handleNumbersChange(e);
                              }
                            }}
                            placeholder={GuestManagementPageText.Search_Guest}
                          />
                          <button
                            type="button"
                            className="btnSearch"
                            onClick={() => search_data()}
                          >
                            Search
                          </button>
                        </div>
                      </div>

                      <div style={{ marginRight: "0" }}>
                        <div className="inputDiv2">
                          <label
                            className="labelPointer"
                            htmlFor="selectFilter"
                          >
                            <img src={FilterIcon} alt="Rapid Car Leasing" />
                          </label>
                          <input
                            type="text"
                            placeholder={GuestManagementPageText.Guest_Filter}
                            value={searchfilter}
                            onInput={handleIaphabetnumberChange}
                            onChange={handleSearch}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div style={{ padding: "0 10px" }}>
                  <div className="cust_hist_card" style={{ padding: "0 20px" }}>
                    <div className="reservationHistoryTable">
                      <div
                        className="historyTableContainer stickyTableheigh274"
                        style={{ overflowX: "auto" }}
                      >
                        <table className="table margin_class_table">
                          <thead className="stickyHeaderClss">
                            <tr>
                              <th scope="col">Sr.No.</th>
                              <th scope="col"> Entry Date</th>
                              <th scope="col">Name</th>
                              <th scope="col"> Image</th>

                              <th scope="col">Action</th>
                            </tr>
                          </thead>
                          <tbody className="custum_border">
                            {currentItems && currentItems.length > 0 ? (
                              currentItems.map((testimonial, index) => (
                                <tr
                                  className="historyTableRow h-auto"
                                  key={index}
                                >
                                  <td>
                                    <div
                                      className="historyTableRowText height50 historyName"
                                      style={{
                                        marginLeft: "20px",
                                      }}
                                    >
                                      {indexOfFirstItem + index + 1}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText height50 historyName">
                                      {mondayDayYearFormat(
                                        testimonial.entry_date
                                      )}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText height50 historyName">
                                      {testimonial.name}
                                    </div>
                                  </td>
                                  <td>
                                    <div
                                      className="guest_incenter "
                                      style={{ width: "20%" }}
                                    >
                                      <img
                                        src={
                                          APL_LINK +
                                          testimonialsImage +
                                          testimonial.image
                                        }
                                        alt={testimonial.name}
                                        className="guest-image"
                                        style={{
                                          maxWidth: "50px",
                                          borderRadius: "50%",
                                        }}
                                      />
                                    </div>
                                  </td>
                                  <td>
                                    <div
                                      className="actioniconstest"
                                      style={{ width: "20%" }}
                                    >
                                      <img
                                        className="del-icon"
                                        src={update}
                                        onClick={() =>
                                          handleEdit(testimonial.primary_id)
                                        }
                                        alt=""
                                        style={{ cursor: "pointer" }}
                                      />
                                      <img
                                        className="del-icon"
                                        src={delicon}
                                        onClick={() =>
                                          handleShowDltModl(
                                            testimonial.primary_id
                                          )
                                        }
                                        alt=""
                                        style={{ cursor: "pointer" }}
                                      />
                                    </div>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={6} className="text_align_center">
                                  No Results Found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="cust_hist_card_footer">
                      <div className="cust_hist_pagination_info">
                        {filteredData && filteredData.length > 0 ? (
                          <>
                            Showing{" "}
                            <span className="cust_hist_pagination_bold">
                              {indexOfFirstItem + 1}
                            </span>{" "}
                            to{" "}
                            <span className="cust_hist_pagination_bold">
                              {Math.min(indexOfLastItem, filteredData.length)}
                            </span>{" "}
                            of{" "}
                            <span className="cust_hist_pagination_bold">
                              {filteredData.length}
                            </span>{" "}
                            cars
                          </>
                        ) : (
                          <>
                            Showing{" "}
                            <span className="cust_hist_pagination_bold">0</span>{" "}
                            cars
                          </>
                        )}
                      </div>
                      <div className="cust_hist_pagination">
                        <nav aria-label="Pagination">
                          <ul className="cust_hist_pagination_list">
                            {renderPaginationButtons()}
                          </ul>
                        </nav>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/**-----------delete car---------------- */}
      <Modal
        className="testMsgModal"
        show={showDltModal}
        onHide={handleDltCloseModal}
        size="md"
        centered
      >
        <Modal.Body>
          <div className="closeBtn" onClick={handleDltCloseModal}>
            <FaTimes className="closeIcn" />
          </div>
          {/* Icon Section */}
          <div className="text-center my-3">
            <FaExclamationCircle
              className="confirmationIcon"
              size={45}
              color="#f44336"
            />
          </div>
          <div className="confirmAtionDltmsG">
            <p>Are You Sure want to delete</p>
          </div>
          <div className="dltBtttn">
            <button type="button" onClick={handleDeleteYes}>
              Yes
            </button>
            <button
              type="button"
              className="noBttn"
              onClick={handleDltCloseModal}
            >
              No
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default CarModelView;
